
import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App.tsx';

console.log("FifaLytics: Inicializando com React 18.3.1...");

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error("Elemento raiz não encontrado");
}

const root = ReactDOM.createRoot(rootElement);
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
